import { html } from 'lit';
import componentStyles from './cta-breaker.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

/**
 * CTA Breaker.
 *
 * @element cta-breaker
 */

export default class CtaBreaker extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {

    return {
      items: { type: Object },
      /**
       * Content
       */
      content: { type: String },
      /**
      * Heading
      */
      heading: { type: String },
    };
  }


  render() {
    return html`
      <div class="cta-breaker">
        <div class="cta-breaker__container">
          <div class="cta-breaker__left">
            <h3 class="cta-breaker__heading">${this.heading}</h3>
            <hf-wysiwyg markup="${this.content}"></hf-wysiwyg>
          </div>
          <div class="cta-breaker__right">
            <div class="cta-breaker__links">
              ${this.items.map(item => {
                return html`
                  <a
                    href="${item.url}"
                    target="_self"
                    linkClass="btn__link--cta-links"
                    >${item.text}</a>
                `;
              })}
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-cta-breaker', CtaBreaker);
